import React from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingScreenProps {
    status?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ status = 'loading.status.starting' }) => {
    const { t } = useTranslation();

    return (
        <div className="fixed inset-0 w-full h-full bg-background-main flex flex-col items-center justify-center z-[9999] text-primary" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
            {/* Logo */}
            <div className="text-[2.5rem] font-[800] mb-6 tracking-tight text-primary">
                KahveInn
            </div>

            {/* Progress Bar Container */}
            <div className="w-[200px] h-1 bg-background-card rounded-full overflow-hidden relative">
                {/* Animated Bar */}
                <div className="absolute top-0 left-0 h-full w-1/2 bg-primary rounded-full animate-[indeterminate_1.5s_infinite_ease-in-out]"></div>
            </div>

            {/* Status Text (Localized) */}
            <div className="mt-4 text-text-secondary text-sm font-medium animate-pulse">
                {t(status)}
            </div>

            {/* Inline Styles for Animation (Scoped) */}
            <style>{`
                @keyframes indeterminate {
                    0% { left: -50%; width: 50%; }
                    50% { left: 25%; width: 75%; }
                    100% { left: 100%; width: 50%; }
                }
            `}</style>
        </div>
    );
};

export default LoadingScreen;
